import React, { useEffect, useState, useRef } from 'react'
import classes from './SeriesVideos.module.scss';
import VideoPlayer from '../../App/VideoPlayer/VideoPlayer';
import { getFileName } from 'helpers/FileCaching';
import {ReactComponent as ArrowSVG } from 'images/components/Global/rightArrow.svg';
import globalJSON from '../../../data/global.json'
import ShareButtonSocials from 'components/App/ShareButtonSocials/ShareButtonSocials'
const seriesVideoThumbnails = require.context('../../../images/components/SeriesVideos/thumbnails', true, /.*\.(gif|png|jpe?g|svg)$/i);
const seriesVideoPosters = require.context('../../../images/components/SeriesVideos/videoposters', true, /.*\.(gif|png|jpe?g|svg)$/i);
const seriesVideo = require.context('../../../images/components/SeriesVideos', true, /.*\.(gif|png|jpe?g|svg)$/i);
const videoImages = require.context('../../../images/components/Video', true, /.*\.(gif|png|jpe?g|svg)$/i);

function SeriesVideos(props) {

    let selectedVideoContent = "";
    let seriesContainers = useRef([])
    let episodeContainers = useRef([])
    let autoPlayVideo = useRef(false)
    let videoPlayerContainerRef = useRef()
    let seriesListItems = useRef([])
    let episodeSelectionRef = useRef({});
    let socialID = props.content.socialId;

    const [videoShareButtonMarkup, setVideoShareButtonMarkup] = useState("")
    const [videoPlayerMarkup, setVideoPlayerMarkup] = useState("")
    const [showVideo, setShowVideo] = useState(false)
    const [episodeSelection, setEpisodeSelection] = useState({
        episode:-1,
        series:props.episodeSelection.series
    });

    const [videoElementStateProps, setVideoElementStateProps] = useState({
        episode:0,
        series:0
    })

    const [shareIconStateProps, setShareIconStateProps] = useState({
        facebookMessage:"",
        twitterMessage:"",
        url:""
    })

    const seriesMarkup = props.content.seriesList.map((item, index) => 
        <div className={classes.series_module__series_episode_wrapper} key={index} >
            <div className={classes.series_module__series_section} ref={(ref) => { seriesContainers.current[index] = ref }}>
                {episodeContainers.current[index] = []}
                {getEpisodesMarkup(index)}
            </div>
        </div>
    )

    //============ COMPONENT CALLBACKS =============//

    function onVideoComplete(){
        console.log("VIDEO COMPLETED!",episodeSelection.episode, episodeContainers.current[episodeSelection.series].length)
        if(episodeSelection.episode < episodeContainers.current[episodeSelection.series].length){
            autoPlayVideo.current = true;
            setEpisodeSelection({
                series: episodeSelection.series,
                episode: (episodeSelection.episode+1)
            })
        }
    }

    //============ USE EFFECT ACTIONS =============//

    function getVideoShareURL(episodeSelectionID,seriesSelectionID){
        return encodeURIComponent(globalJSON.live_url+process.env.PUBLIC_URL+"/index.html?episode="+(episodeSelectionID+1)+"&series="+(seriesSelectionID+1))
    }



    useEffect(() => {
        setEpisodeSelection(props.episodeSelection)
    },[props.episodeSelection])

    useEffect(() => {
        //Force the video to re-render with new props
        setShowVideo(false)
        updateVideoMarkupProps()
    },[props.windowSize])

    useEffect(() => {
        //Force the video to re-render with new props
        setTimeout(() => {
            setShowVideo(true)
        }, 100);
    },[showVideo])

    function updateVideoMarkupProps(){
        props.content.seriesList.forEach(series => {
            series.episodes.forEach(episode => {
                episode.videoElement= 
                    <VideoPlayer 
                        onComplete={() => onVideoComplete()} 
                        content={episode.video} 
                        videoImages={seriesVideoPosters} 
                        windowSize={props.windowSize} 
                        autoPlay={autoPlayVideo.current}
                    />

            });
        });
    }

    useEffect(() => {
        updateVideoMarkupProps()
    },[props.content])

    useEffect(() => {
        if(episodeSelection !== undefined){
            showSeriesTab(episodeSelection.series)
            if(episodeSelection.episode !== -1){
                selectedVideoContent = props.content.seriesList[episodeSelection.series].episodes[episodeSelection.episode].video;

                setVideoElementStateProps(episodeSelection)
                setShowVideo(false)
                setShareIconStateProps({

                    facebookMessage:props.content.seriesList[episodeSelection.series].episodes[episodeSelection.episode].share.facebook.description,
                    twitterMessage:props.content.seriesList[episodeSelection.series].episodes[episodeSelection.episode].share.twitter.description,
                    url:getVideoShareURL(episodeSelection.episode, episodeSelection.series)

                })
                episodeContainers.current.forEach(seriesElement => {
                    seriesElement.forEach(element => {
                        
                        element.classList.remove(classes['series_module__episode_item--is_playing']);
        
                    })
                });
                episodeContainers.current[episodeSelection.series][episodeSelection.episode].classList.add(classes['series_module__episode_item--is_playing'])
            }
        }
        updateVideoMarkupProps()
    },[episodeSelection])

    //============ DOM MAINUPLATION =============//

    function showSeriesTab(index){

        seriesContainers.current.forEach(element => {
            element.classList.remove(classes.series_module__series_section_selected)
        });

        seriesContainers.current[index].classList.add(classes.series_module__series_section_selected)

    }

    //============ MARKUP LOADING FUNCTIONS =============//

    function getIsLiveClasses(isLive){
        if(isLive === false){
           
            return `${classes['series_module__episode_item']} ${classes['series_module__episode_item--is_not_live']}`
        }else{
            
            return `${classes['series_module__episode_item']}`
        }
    }

    function getEpisodesMarkup(series){
        let episodesMarkup = ""
        console.log(props.content.seriesList[series].isSeries)
        if(episodeSelection !== undefined){
            episodesMarkup = props.content.seriesList[series].episodes.map((item, index) => 
            <div 
                className={getIsLiveClasses(item.isLive)} 
                key={index} 
                onClick={(item.isLive === false ? () => null : (event) => episodeClick({series:series, episode:index, target:event.target}))}
                ref={(ref) => { episodeContainers.current[series][index] = ref }}
            >
                <div className={classes.series_module__is_playing_bg}>
                    <div className={classes.series_module__container}> 
                        <img alt={item.imgTitle} src={getFileName(seriesVideoThumbnails,item.image[props.windowSize])} className={classes.series_module__image}/>
                        <div className={`overlay_titles_bottom`}></div>
                        <div className={classes.series_module__hover}></div>
                    </div>
                    <img alt={"play button"} src={getFileName(videoImages,"playBtn.svg")} className={classes.series_module__playBtn}/>
                    
                    <div className={`${(props.content.seriesList[series].isSeries ? classes['series_module__episode_tag']  : classes['series_module__episode_tag__hidden'])}` }>

                        <span className={classes.series_module__episode_number}>Ep{index+1}</span>
                    </div>
                    
                    {(
                        item.liveDate !== undefined ? 
                            <div className={classes.series_module__live_date}>
                                <span className={classes.series_module__date}>{item.liveDate}</span>
                            </div>
                        : 
                            ""
                    )}
                    <div className={classes.series_module__episode_title}>
                        {(episodeSelection.series === series && episodeSelection.episode === index ?
                            "Currently watching"
                            :
                            item.title
                        )}
                    </div>
                </div>
            </div>
            )
        }
        return episodesMarkup;

    }

    function getSeriesNav(){
        if(episodeSelection !== undefined){
            let seriesMarkup = props.content.seriesList.map((item, index) => 
                <div>
                    <li key={index} onClick={() => seriesClick(index)} className={classes.series_module__selection}>
                        <h3 className={`
                                        ${classes.series_module__selection_title}
                                        ${(episodeSelection.series === index 
                                            ? 
                                            classes['series_module__selection_title--active'] 
                                            : 
                                            "")}`
                                            }>
                                {item.title}<span className={classes.series_module__selection_arrow}><ArrowSVG/></span>
                        </h3>
                    </li>
                </div>
            )
        }else{
            return <div></div>
        }

    }

    function getSeriesNav(){
        if(episodeSelection !== undefined){
            let seriesMarkup = props.content.seriesList.map((item, index) => 
                <li key={index} onClick={() => seriesClick(index)} className={classes.series_module__selection}>
                    <h3 className={`
                                    ${classes.series_module__selection_title}
                                    ${(episodeSelection.series === index 
                                        ? 
                                        classes['series_module__selection_title--active'] 
                                        : 
                                        "")}
                                `}>
                        {item.title}
                    </h3>
                </li>
            )
            return seriesMarkup;
        }else{
            return <div></div>;
        }
    }

    //============EPISODE CLICK EVENTS=============//

    function episodeClick(epsodeDetails){

        if(props.windowSize === "desktop"){
            autoPlayVideo.current = true;
        }

        updateVideoMarkupProps()
        videoPlayerContainerRef.current.scrollIntoView({behavior:"smooth"});
        setEpisodeSelection(epsodeDetails)
    
    }

    function seriesClick(selectedIndex){

        setEpisodeSelection({
            series:selectedIndex,
            episode:-1
        })

    }


    return (
        <section className={classes.series_module}>
            {/* <SectionHero content={jsonHub.seriesVideos} windowSize={props.windowSize}/> */}
                <div className={classes.series_module__bgImage_container}>
                    <div className={classes.series_module__bgImage} 
                        style={{backgroundImage: `url(${getFileName(seriesVideo, 'bg_preview.png')})`, }}
                        title={'preview'}
                    >
                        <div className={classes.series_module__bgImage_overlay}>
                
                            <div className={classes.series_module__content_wrapper}>
                                <div id="series_module__video_container" ref={videoPlayerContainerRef} className={classes.series_module__video}>
                                    <div className={`aspect-ratio-box`}>
                                        <div className={`aspect-ratio-box-inside`}>
                                            {(showVideo ? props.content.seriesList[videoElementStateProps.series].episodes[videoElementStateProps.episode].videoElement : "")}
                                        </div>
                                    </div>
                                    <div className={classes.series_module__video_share__container}><p style={{display:"inline-block"}}>{props.content.shareMessage}</p>
                                        {(
                                            showVideo ? 
                                            ////// new one
                                            <div className={`series-videos`}>
                                                <ShareButtonSocials url={shareIconStateProps.url} 
		                                        description={shareIconStateProps.facebookMessage}
                                                twitterDescription={shareIconStateProps.twitterMessage}
                                                socialID={socialID}></ShareButtonSocials>
                                            </div>
                                            ////// old one
                                            // <BlueSocialIcon 
                                            //     url={shareIconStateProps.url}
                                            //     description={shareIconStateProps.facebookMessage}
                                            //     twitterDescription={shareIconStateProps.twitterMessage}
                                            // />
                                            :
                                            ""
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.series_module__list_container} >
                        <div className={classes.series_module__list_wrap}>
                            <ul className={classes.series_module__list}>
                                {getSeriesNav()}
                            </ul>
                
                        </div>
                    
                        <div className={`${classes.series_module__selection_container}`}>
                            {seriesMarkup}
                        </div>
                      
                    </div>
                  
                </div>
           
        </section>
    )

}

export default SeriesVideos;
